import { IconButton } from '@ui';
import { useState } from 'react';
import { CheckIcon, CopyIcon } from '../icons';

/**
 * Тб1: an address, a token or a path — mono text with «Копировать», not a status badge (a badge is for statuses and
 * marks only; `widget/tests/no-value-badge.test.ts`).
 */
export function CopyValue({ value, shown, tip }: { value: string; shown?: string; tip?: string }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    void navigator.clipboard?.writeText(value).then(
      () => {
        setCopied(true);
        window.setTimeout(() => setCopied(false), 1500);
      },
      () => undefined,
    );
  };
  return (
    <span className="jui-row bug-copy-value" title={tip}>
      <span className="mono bug-copy-text">{shown ?? value}</span>
      <IconButton size="sm" label={copied ? 'Скопировано' : 'Копировать'} icon={copied ? <CheckIcon /> : <CopyIcon />} onClick={copy} />
    </span>
  );
}
